import i18next, { t as translate, TFunction } from 'i18next';
import { Languages } from '../entities';

type TFunctionKeys = Parameters<TFunction>[0];

export const getCurrentLanguage = () => {
  return i18next.language as Languages;
};

export const t = (local: TFunctionKeys): string => {
  return translate(local);
};
